"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentSeriesSchemaDef = exports.examDateSchemaDef = exports.submissionOffsetSchemaDef = exports.submissionWindowSchemaDef = void 0;
const joi_1 = __importDefault(require("joi"));
const Series_1 = require("./Series");
const schemaValidator_1 = require("../../util/schemaValidator");
exports.submissionWindowSchemaDef = Object.assign(Object.assign({}, Series_1.submissionWindowBaseSchemaDef), { start: (0, Series_1.dateSchema)().required(), end: (0, Series_1.dateSchema)().required(), persistStartDate: joi_1.default.boolean().optional(), persistEndDate: joi_1.default.boolean().optional() });
exports.submissionOffsetSchemaDef = {
    date: joi_1.default.number().min(0),
    buffer: joi_1.default.number().min(0),
};
exports.examDateSchemaDef = {
    date: (0, Series_1.dateSchema)().required(),
    examTimeOfDay: joi_1.default.string().valid('AM', 'PM').required().allow(null),
    zone: joi_1.default.string().allow(null),
    zoneId: joi_1.default.string().allow(null),
    submissionOffset: (0, schemaValidator_1.objectSchema)(exports.submissionOffsetSchemaDef),
    noModification: joi_1.default.boolean(),
    isExam: joi_1.default.boolean(),
};
exports.componentSeriesSchemaDef = Object.assign(Object.assign({}, Series_1.seriesBaseSchemaDef), { examDates: (0, schemaValidator_1.arraySchema)(exports.examDateSchemaDef).default([]), salgoStartDate: (0, Series_1.dateSchema)().optional(), submissionWindow: (0, schemaValidator_1.objectSchema)(exports.submissionWindowSchemaDef), marksSubmissionWindow: (0, schemaValidator_1.objectSchema)(exports.submissionWindowSchemaDef) });
